//
import React from "react";
//component
import { Form, Input } from "antd";
//redux
//selector
//actions
//utils
//hook
//str

const { TextArea } = Input;

const FormTextAreaClone = (props) => {
  // -------------------------- VAR -----------------------------
  const label = props.label;
  const name = props.name || "Tên";
  const placeholder = props.placeholder || "Nhập Mô Tả";
  const className = props?.className || "";
  const rules = props?.rules || [];
  const rows = props?.rows || 3;
  const disabled = props?.disabled || false;
  const initialValue = props?.initialValue;
  const showCount = props?.showCount;
  const variant = props?.variant || "outlined";
  const readOnly = props?.readOnly || false;
  const onSelect = props?.onSelect;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Form.Item
      name={name}
      label={label}
      initialValue={initialValue}
      rules={rules}
    >
      <TextArea
        className={className}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        showCount={showCount}
        variant={variant}
        onSelect={onSelect}
        onBlur={() => {
          console.log({ start: 0, end: 0 });
        }}
      />
    </Form.Item>
  );
};
export default FormTextAreaClone;
